export default __webpack_public_path__ + "static/media/milita-offer-top.33086701.jpg";